import React from 'react';
import { Tooltip } from '@byte-design/ui';
import { observer, useLocalStore } from 'mobx-react';

interface Props{
  className?: string;
  style?: any;
  content?: string;
  children?: JSX.Element;
}
const Tips: React.FC<Props> = ({
  content, children, style, className,
}) => {
  const state = useLocalStore(() => ({
    show: false,
  }));

  return (
    <Tooltip
      lazyInit
      trigger="manual"
      show={state.show}
      mode="white"
      placement="top"
      content={content}
      className={className}
      style={style}
      onMouseOver={() => {
        state.show = true;
      }}
      onMouseLeave={() => {
        state.show = false;
      }}
    >
      {children}
    </Tooltip>
  );
};

export default observer(Tips);
